<template>
  <div class="onboarding-step1" :class="{ 'has-warning': $parent.showWarningAcceptPolicy }">
    <div class="step1-content scrollbar">
      <aula-spinner v-if="isLoading" />
      <template v-else>
        <h1 class="step1-title">
          {{ $getText('POLICY_TITLE') }}
        </h1>
        <template v-if="dataPolicy.changesDescription && dataPolicy.changesDescription.html">
          <div class="privacy-policy-changes">
            <div v-html="dataPolicy.changesDescription.html" />
          </div>
        </template>
        <p>{{ $getText('POLICY_SUMMARY_1_1') }}</p>

        <b>{{ $getText('PRIVATE_POLICY') }}</b>
        <p>
          {{ $getText('POLICY_SUMMARY_2_1') }}
        </p>
        <p>
          {{ $getText('POLICY_SUMMARY_3_1') }}
          <a
            v-for="policy in getPersonalDataPolicies"
            :key="policy.institutionCode"
            :href="policy.commonFile.file.file.url"
            class="policy-link"
            download
            target="_blank"
          >
            {{ policy.commonFile.title }}
            ({{ policy.institution.institutionName }}), </a
          >{{ $getText('POLICY_SUMMARY_3_2') }}
        </p>
        <b>{{ $getText('POLICY_TITLE_DATAEHTICS') }}</b>
        <p>
          {{ $getText('POLICY_SUMMARY_4_1') }}
          <a
            href="#"
            @click="
              $refs.privacyDataEhtics.show();
              return false;
            "
            >{{ $getText('AULA_DATA_EHTICS') }}</a
          >
          {{ $getText('POLICY_SUMMARY_4_2') }}
        </p>
      </template>
    </div>
    <div class="accept-container">
      <b-form-checkbox v-model="$parent.isPolicyAccepted" class="accept" @input="acceptChange">
        {{ $getText('READ_AND_AGREE') }}
      </b-form-checkbox>
      <b-alert variant="danger" class="warning" :show="$parent.showWarningAcceptPolicy">
        {{ $getText('WARNING_ACCEPT_THE_POLICY') }}
      </b-alert>
    </div>
    <aula-modal
      ref="privacyPolicyModal"
      :disable-portal="true"
      :show-ok="false"
      :show-cancel="isMobile"
      header-text="PRIVATE_POLICY"
      @cancelClicked="$refs.privacyPolicyModal.hide()"
    >
      <div v-if="dataPolicy.content && dataPolicy.content.html" v-html="dataPolicy.content.html" />
    </aula-modal>
    <aula-modal
      ref="privacyDataEhtics"
      :disable-portal="true"
      :show-ok="false"
      :show-cancel="isMobile"
      header-text="AULA_DATA_EHTICS"
      @cancelClicked="$refs.privacyDataEhtics.hide()"
    >
      <div class="p-4" v-html="$getText('AULA_DATA_ETHICS_DETAILS')" />
    </aula-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { types } from '../../store/types/types';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function () {
    return {
      isLoading: false,
      Vue: Vue,
    };
  },
  computed: {
    ...mapGetters({
      getPersonalDataPolicies: types.GET_PERSONAL_DATA_POLICIES,
      dataPolicy: types.GET_DATA_POLICY,
      isMobile: types.GET_IS_MOBILE,
    }),
  },
  methods: {
    acceptChange() {
      if (!this.$parent.isPolicyAccepted) {
        this.$parent.showWarningAcceptPolicy = true;
      } else {
        this.$parent.showWarningAcceptPolicy = false;
      }
    },
    ...mapActions({
      loadPersonalDataPolicies: types.LOAD_PERSONAL_DATA_POLICIES,
      loadDataPolicy: types.LOAD_DATA_POLICY,
    }),
  },
  mounted() {
    this.isLoading = true;
    this.loadDataPolicy();
    if (!this.getPersonalDataPolicies) {
      this.loadPersonalDataPolicies().then(() => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;

.onboarding-step1 {
  .accept-container {
    @include breakpoint-lg-down() {
      width: 100%;
      background: $color-primary-base;
      position: fixed;
      left: 0;
      bottom: 0;
      padding: 15px 20px;
      color: $color-white;
    }
  }
  ::v-deep a {
    font-weight: bold;
  }
  height: 100%;
  @include breakpoint-lg-down() {
    height: auto;
  }
  .privacy-policy-changes {
    background: $color-grey-base;
    padding: 10px;
    margin-bottom: 20px;
  }
  .step1-title {
    font-size: 36px;
    font-weight: 900;
    line-height: 40px;
    margin-bottom: 30px;
    @include breakpoint-lg-down() {
      font-size: 24px;
    }
  }
  .step1-content {
    overflow-x: auto;
    height: 95%;
    margin-bottom: 20px;
    padding-right: 20px;
    @include breakpoint-lg-down() {
      height: 90%;
    }
    @include breakpoint-lg-down() {
      height: auto;
    }
  }
  .scrollbar {
    @include breakpoint-lg-down() {
      overflow-y: hidden;
    }
  }
  a {
    .theme-employee & {
      color: $color-primary-dark-employee;
    }
    .theme-guardian & {
      color: $color-primary-dark-guardian;
    }
    .theme-child & {
      color: $color-primary-dark-child;
    }
    .theme-admin & {
      color: $color-primary-dark-admin;
    }

    text-decoration: underline;
  }
  &.has-warning {
    .step1-content {
      height: 87% !important;
      @include breakpoint-lg-down() {
        height: 82% !important;
      }
    }
    .accept-container {
      @include breakpoint-lg-down() {
        padding-left: 30px !important;
        padding-top: 10px;
      }
      .warning {
        margin-bottom: 5px;
        padding-bottom: 0px;
        margin-left: -2px;
      }
    }
  }
}
</style>
